import React from 'react';

import useTextContentField from '../../../hooks/useTextContentField';
import { useStore } from '../../../hooks';

const DrawInspectorTextContentField = () => {
  const { t } = useStore();
  const {
    textId,
    draft,
    fieldRef,
    handleBlur,
    handleChange,
    handleFocus,
    handleKeyDown,
  } = useTextContentField();

  if (!textId) {
    return null;
  }

  return (
    <div
      className="respark_draw-inspector-text-content"
      data-testid="draw-inspector-text-content"
    >
      <textarea
        id="respark_draw-inspector-text-input"
        ref={fieldRef}
        className="respark_draw-inspector-text-content__input"
        rows={3}
        value={draft}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        placeholder={t('drawInspectorTextPlaceholder')}
        aria-describedby="respark_draw-inspector-text-hint"
        aria-label={t('drawInspectorTextLabel')}
        spellCheck
      />
      <p
        id="respark_draw-inspector-text-hint"
        className="respark_draw-inspector-text-content__hint"
      >
        {t('drawInspectorTextHint')}
      </p>
    </div>
  );
};

export default DrawInspectorTextContentField;
